import React, { createRef, FunctionComponent, MouseEventHandler } from "react";

import { AlignItems, FlexDirection, Layout } from "@multiweb/reactComponents";
import { bemClassNames, TAB_INDEX_FOCUSABLE_ONLY, useContentOverflows } from "@multiweb/reactUtils";

export type MenuTitleProps = {
    /** Zobrazovaný text */
    text: string | undefined;
    /** Podnadpis zobrazovaný pod hl. textem */
    subtitle?: string;
    /** onClick callback */
    onClick?: MouseEventHandler;
};

const classNames = bemClassNames("menu-title");

export const MenuTitle: FunctionComponent<MenuTitleProps> = ({ text, onClick, subtitle }) => {
    const ref = createRef<HTMLDivElement>();
    const contentOverflows = useContentOverflows<HTMLDivElement>(ref);

    return (
        <Layout>
            <div
                className={classNames({ clickable: onClick != null })}
                title={contentOverflows ? text : undefined}
                role={onClick ? "button" : undefined}
                tabIndex={onClick ? TAB_INDEX_FOCUSABLE_ONLY : undefined}
                onKeyDown={undefined}
                {...{ ref, onClick }}
            >
                {text && (
                    <Layout alignItems={AlignItems.center}>
                        <Layout flexDirection={FlexDirection.column}>
                            <span>{text}</span>
                            {subtitle ? <span className="subtitle">{subtitle}</span> : undefined}
                        </Layout>
                    </Layout>
                )}
            </div>
        </Layout>
    );
};
